import { Injector, StaticProvider, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { JobOverviewModel, JobQuery, JobStore } from '../state';
import { ACTIVE_JOB_OVERVIEW_MODEL, ActiveJobOverviewModel } from './active-job-overview-model.injection-token';
import { JOB_OVERVIEW_MODELS } from './job-overview-table.injection-token';
import { AbstractJobService } from './job.service';
import { JobContextService } from './services/job-context.service';

export interface JobServiceDef {
  JobService: Type<AbstractJobService>;
  JobStore: Type<JobStore>;
  JobQuery: Type<JobQuery>;
  /**
   * An Observable that returns objects containing one or more jobs.
   * Either ExportTrigger or DatasourceTable models.
   */
  JOB_OVERVIEW_MODELS: (injector: Injector) => Observable<JobOverviewModel[]>;
  /**
   * An Observable that returns the currently active model containing one or more jobs.
   * Either ExportTrigger or DatasourceTable models.
   */
  ACTIVE_JOB_OVERVIEW_MODEL: (injector: Injector) => ActiveJobOverviewModel;
}

export function provideJob(providers: JobServiceDef): StaticProvider[] {
  const {
    JobService: jobService,
    JobStore: store,
    JobQuery: query,
    ACTIVE_JOB_OVERVIEW_MODEL: activeJobOverviewModel,
    JOB_OVERVIEW_MODELS: jobOverviewModels,
  } = providers;
  return [
    {
      provide: AbstractJobService,
      useExisting: jobService,
    },
    {
      provide: JobStore,
      useExisting: store,
    },
    {
      provide: JobQuery,
      useExisting: query,
    },
    {
      provide: ACTIVE_JOB_OVERVIEW_MODEL,
      deps: [Injector],
      useFactory: activeJobOverviewModel,
    },
    {
      provide: JOB_OVERVIEW_MODELS,
      useFactory: jobOverviewModels,
      deps: [Injector],
    },
    {
      provide: JobContextService,
      useClass: JobContextService,
    },
  ];
}
